/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { connect } from "react-redux";

import Button from "components/Button/Button";

import styles from "./Player.module.scss";

import AppLayoutWrapFull from "components/AppLayoutWrapFull";

// import PageHeader from "components/PageHeader/PageHeader";
// import { ONLY_OFFICE_JS } from  "helpers/ApiEndpointConstants";

import {
    loadFoldersAction,
} from "store/actions/Actions";

const Player = props => {

    const { loadFoldersAction, UserOrgSiteReducer } = props;
    const is_admin = (UserOrgSiteReducer && UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_admin) ? true : false;

    const { id } = props.match.params;

    useEffect(() => {
        loadFoldersAction({ id });
    },  [id, loadFoldersAction]);

    var getFolderIcon = function() {
        return (
            is_admin ? 
            <div className={styles['path']}><a href="/achieve/documents"><i className={`fal fa-folder-open ${styles['up']}`}></i></a> {props.folders.path}</div>
                :
            <div className={styles['path']}></div>
        )
    }

    return (
        
        <AppLayoutWrapFull>

            {props.folders && getFolderIcon()}

            <div className={styles['holder']}>

                {props.folders &&
                    <div id="video" className={styles.video}>

                        <div className={styles['close']}>
                            <Button
                                className={styles.button}
                                text={"CLOSE"}
                                icon="fal fa-times"
                                onClick={() => props.history.goBack()}
                                size="md"
                            />
                        </div>

                        <video width="100%" height="auto" autoPlay={true} controls src={props.folders.url} />
                    </div>
                }
            </div>
        </AppLayoutWrapFull>
    );
};


const mapStateToProps = state => ({
    folders: state.FoldersReducer.folders,
    UserOrgSiteReducer: state.UserOrgSiteReducer
});

const mapDispatchToProps = {
    loadFoldersAction
};

// export default Documents;
export default connect(mapStateToProps, mapDispatchToProps)(Player);
